// Estados de pago individuales
const PAYMENT_STATES = {
  PENDING: "pending",
  PAID: "paid",
  EXPIRED: "expired",
};

// Mapeo de IDs de estado a nombres
const PAYMENT_STATUS_ID_MAP = {
  1: "pending",
  3: "paid",
  4: "expired",
};

// Mapeo inverso de nombres a IDs
const PAYMENT_STATUS_NAME_MAP = Object.entries(PAYMENT_STATUS_ID_MAP).reduce(
  (acc, [id, name]) => {
    acc[name] = parseInt(id);
    return acc;
  },
  {}
);

// Grupos de estados para validaciones comunes
const PAYMENT_STATE_GROUPS = {
  paid: ["paid"],
  // confirmable: ["to_confirm", "not_reported"],
  actionable: ["pending", "expired"],
};

export {
  PAYMENT_STATES,
  PAYMENT_STATE_GROUPS,
  PAYMENT_STATUS_ID_MAP,
  PAYMENT_STATUS_NAME_MAP,
};
